module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twitch",
    class: {
      ss: _vm.showStreamerSquare
    }
  }, [_c('div', {
    staticClass: "twitch-description"
  }, [_c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "link-btn title",
    class: {
      selected: !_vm.showStreamerSquare
    },
    attrs: {
      "aria-label": "switch to streaming lowco",
      "title": "switch to streaming lowco"
    },
    on: {
      "click": function($event) {
        return _vm.changeStream('lowco')
      }
    }
  }, [_c('h2', [_vm._v("My Twitch")])]), _vm._v(" "), _c('span', {
    staticClass: "spacers",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "link-btn title ss",
    class: {
      selected: _vm.showStreamerSquare
    },
    attrs: {
      "aria-label": "switch to streaming StreamerSquare",
      "title": "switch to streaming StreamerSquare"
    },
    on: {
      "click": function($event) {
        return _vm.changeStream('StreamerSquare')
      }
    }
  }, [_c('h2', [_vm._v("StreamerSquare")])]), _vm._v(" "), _c('span', {
    staticClass: "spacers",
    staticStyle: {
      "flex": "2"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showStreamerSquare),
      expression: "showStreamerSquare"
    }]
  }, [_c('p', [_vm._v("StreamerSquare is a website and stream dedicated to helping others in the streaming industry")]), _vm._v(" "), _c('p', [_vm._v("StreamerSquare is "), _c('stream-status', {
    attrs: {
      "channelId": '61099751',
      "channelName": 'streamer-square'
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showStreamerSquare),
      expression: "!showStreamerSquare"
    }]
  }, [_c('p', [_vm._v("I mostly play popular/new games for PC, PS4, and XB1.")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin-top"
  }, [_vm._v("My schedule: "), _c('stream-times')], 1), _vm._v(" "), _c('p', [_vm._v("Lowco is "), _c('stream-status', {
    attrs: {
      "channelId": '52925091',
      "channelName": 'lowco'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "twitch-stream",
    class: {
      ss: _vm.showStreamerSquare
    }
  }, [_c('iframe', {
    attrs: {
      "src": 'https://player.twitch.tv/?channel=' + _vm.stream + '&parent=' + _vm.domainName + '&muted=true',
      "frameborder": "0",
      "scrolling": "no",
      "title": "Lowco's embedded twitch stream"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "website"
  }, [_vm._v("Website: "), _c('a', {
    staticClass: "link-btn title ss",
    attrs: {
      "href": "https://streamersquare.com/",
      "title": "StreamerSquare.com"
    }
  }, [_vm._v("StreamerSquare.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6af22b16","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Twitch.vue
// module id = 1174
// module chunks = 2